module.exports = __webpack_public_path__ + "static/media/pulang-bato.4637232a.jpg";